import useMediaQuery from '@mui/material/useMediaQuery';

import variables from 'src/style/variable/variables.module.scss';

/**
 * The app's two width breakpoints, from the same SCSS variables the
 * stylesheets use. Both were repeated inline across the screens; this is the
 * one place they're read.
 *
 * `isPhone` implies `isMobile` -- phone is the narrower of the two.
 *
 * @returns {{ isMobile: boolean, isPhone: boolean }} the active breakpoints
 */
export default function useBreakpoint () {
  const isMobile = useMediaQuery(`(max-width: ${variables.mobileWidth})`);
  const isPhone = useMediaQuery(`(max-width: ${variables.phoneWidth})`);

  return { isMobile, isPhone };
}
